<template>
  <v-card dark class="bg-purple book-card-carousel w-100">
    <v-row class="px-4 py-4 ma-0 flex-nowrap carousel-wrap">
        <v-col 
            cols="auto"
            class="pl-0 py-0"
        >
          <div class="cover-img empty w-100">
            <v-btn
              elevation="0"
              icon
              x-large
              @click="$router.push(`/user/library`)"
              >
              <v-icon
                  class="rounded-circle"
              >mdi-plus</v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="auto"  class="text-left py-0 pr-0 flex-fill">
          <v-row class="ma-0">
            <span class="book-tag mb-2" v-if="!assigned">{{ $t('home.own_taste') }}</span>
            <span class="book-tag mb-2" v-if="assigned">{{ $t('home.assigned_book') }}</span>
          </v-row>
          <h4 class="mb-2" v-if="!assigned">{{ $t('home.no_book_title')}}</h4>
          <h4 class="mb-2" v-if="assigned">{{ $t('home.no_book_assigned_title')}}</h4>
          <p class="mb-1" v-if="!assigned">{{ $t('home.no_book_content')}}</p>
          <p class="mb-1" v-if="assigned">{{ $t('home.no_book_assigned')}}</p>

          <div class="progress-bar mb-1">
            <label for="">{{ $t('home.your_progress') }}</label>
            <div class="progress-bar__container">
              <v-progress-linear
                  background-color="#514585"
                  color="#C4BBE7"
                  :value="completedTasksPercentage"
                  height="15"
                  rounded
              >
                <strong>{{completedTasks}} / {{ totalTasks }} {{ $t('home.pages') }}</strong>
              </v-progress-linear>
            </div>
          </div>
      </v-col>
    </v-row>

  </v-card>
</template>

<script>
export default {
  data: () => ({
      show: false,
      knowledge: 100,
      treasure: require('@/assets/img/icons/treasure-stroke.png'),
      completedTasks: 0,
      totalTasks: 0
    }),
  props: [ 'imgSource', 'title', 'description', 'tag', 'endDate', 'progress', 'status', 'assigned' ],
  computed: {
    completedTasksPercentage() {
      return (this.completedTasks / this.totalTasks) * 100;
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-purple {
    background: linear-gradient(310.15deg, #A295DA -3.77%, #7764CA 29.51%, #6857B2 65.63%, #514585 93.49%);
}
.carousel-wrap{
  min-height: 180px;
  @media screen and (max-width: 960px) {
    min-height: 200px;
  }
}
.book-card-carousel{
    border: none;
    border-radius: 12px;
    min-height: 250px;
    padding: 12px;
    @media screen and (max-width: 1366px) {
        min-height: 265px;
    }
    @media screen and (max-width: 1263px) {
        min-height: 270px;
    }
    @media screen and (max-width: 959px) {
      min-height: 250px;
    }
    @media screen and (max-width: 767px) {
      min-height: 235px;
    }
    h4{
        line-height: 110%;
        // @media screen and (min-width: 960px) {
        //     min-height: 2em;
        // }
    }
    p{
        font-size: .8rem;
        line-height: 120%;
    }
}
.cover-img{
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 120px;
    &.empty{
        background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%);
        border: 2px dashed #EEECF8;
        border-radius: 1em;
        height: 100%;
        min-height: 168px;
        min-width: 140px;
        max-width: 140px;
        @media screen and (max-width: 959px) {
            min-height: 150px;
            min-width: 120px;
            max-width: 120px;
        }
    }
    .v-btn{
        background: #EEECF8;
        box-shadow: inset 0px 0px 4px rgba(73, 60, 130, 0.5);
        .v-icon{
            background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

}
.v-progress-linear{
  &.v-progress-linear--rounded{
    border-radius: 20px;
  }

}
::v-deep{
  .v-progress-linear__content{
    font-size: .7em;
    line-height: 100%;
    color: #C4BBE7;
  }
}
</style>